import { FetchError } from '../fetchError';

import { getCookie } from 'cookies-next';
import { StatusCodes } from 'http-status-codes';

async function fetcher<T>(url: string, options: RequestInit = {}): Promise<T> {
  const criblCsrf = getCookie('cribl_csrf')?.toString();
  const requestInit: RequestInit & { 'xsrf-token'?: string } = {
    credentials: 'include',
    mode: 'cors',
    method: 'GET',
    ...options,
  };

  if (criblCsrf) {
    requestInit['xsrf-token'] = criblCsrf;
  }

  const response = await fetch(url, requestInit);

  if (!response.ok) {
    const responseType = response.headers.get('content-type');
    const responseBody = responseType && responseType.includes('json') ? await response.json() : await response.text();
    const serverMsg =
      typeof responseBody === 'object' && 'message' in responseBody
        ? responseBody.message
        : 'An error occurred while fetching';

    throw new FetchError(serverMsg, response.status, responseBody);
  }

  if (response.status === StatusCodes.NO_CONTENT) {
    return undefined as unknown as T;
  }

  if (response.status === StatusCodes.ACCEPTED) {
    return response as Response as T;
  }

  const contentType = response.headers.get('Content-Type');
  const isAllowedTextBasedResponse =
    contentType && ['text/csv;', 'text/html;'].some((type) => contentType.includes(type));

  if (isAllowedTextBasedResponse) {
    return (await response.text()) as unknown as T;
  }

  return response?.json();
}

export default fetcher;
